import { render, staticRenderFns } from "./ai-pagination.vue?vue&type=template&id=16256634&lang=html"
import script from "./ai-pagination.vue?vue&type=script&lang=js"
export * from "./ai-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports